import { Logger } from '~/app-modules/logger/logger';

export const useAppLogger = () => {
  return useIOC(Logger);
};
